import React from 'react';
import { createRoot } from 'react-dom/client';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './assets/css/geist-fonts.css';
import './assets/css/tailwind.css';
import App from './App';

// Theme initializer (cookie-based): loads style.css/style-dark.css and toggles `.dark`.
// Preference is stored in cookie `smart-theme` so other internal apps can reuse it.
import { initThemeFromCookie } from './Utils/themeManager';
initThemeFromCookie();

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
